define('modules/resources/classic/js/base.js',["app/config","jquery","templates","skrollr","waypoints"], function(config,$,templates,skrollr) {
    return {
        name: 'resources',
        selectors: '#resources',
        remoteData: [config.urls.resources],
        initialize: function(data) {
        
		$(this.selectors).append(templates.resourcepostclassic({
			posts: data
		}));

        }
    }
});
